import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Button,
  FormLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "../../../components/ui";
import { toast } from "react-toastify";
import axiosInstance from "../../../axios/axiosInstance";

interface Prop {
  onClose: () => void;
  id?: any;
}

const RelationshipForm: React.FC<Prop> = ({ onClose, id }) => {
  const [formData, setFormData] = useState<any>();
  const [userData, setUserData] = useState<any>();
  const [Marriage, setMarriage] = useState<any>();

  const [initialFormData, setInitialFormData] = useState<any>();

  const handleAdd = async () => {
    try {
      const resp = await axiosInstance.post("/api/relationship", formData);
      if (resp?.status === 200) {
        toast.success("Relationship created successfully");
        onClose();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };
  const handleGetUsers = async () => {
    try {
      const resp: any = await axiosInstance.get(`/api/user?search=`);
      if (resp.status === 200) {
        setUserData(resp?.data?.data?.data);
      }
    } catch (Error: any) {
      toast.error(Error?.response?.data?.message);
    }
  };

  const handleGetMarriage = async () => {
    try {
      const resp: any = await axiosInstance.get(`/api/marriage`);
      if (resp.status === 200) {
        setMarriage(resp?.data?.data);
      }
    } catch (Error: any) {
      toast.error(Error?.response?.data?.message);
    }
  };

  const handleEdit = async () => {
    try {
      const resp = await axiosInstance.put(`/api/relationship/${id}`, formData);
      if (resp?.status === 200) {
        toast.success("Relationship updated successfully");
        onClose();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };

  const handleGet = async (id: any) => {
    try {
      const resp: any = await axiosInstance.get(`/api/relationship/${id}`);
      if (resp.status === 200) {
        resp.data.data.of_person = resp?.data?.data?.ofPerson?.id;

        resp.data.data.person = resp?.data?.data?.person?.id;
        resp.data.data.marriage_id = resp?.data?.data?.marriage?.id;

        setFormData(resp?.data?.data);
        setInitialFormData(resp?.data?.data);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    }
  };

  const handleChange = (field: string, value: string) => {
    setFormData((prev: any) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    if (id) {
      const noFieldChanges =
        JSON.stringify(initialFormData) === JSON.stringify(formData);
      if (noFieldChanges) {
        toast.info("No changes were made");
        return;
      }
    }

    if (!formData?.person || !formData?.of_person || !formData?.relation) {
      toast.error("All fields are required");
      return;
    }

    if (id) {
      await handleEdit();
    } else {
      await handleAdd();
    }
  };

  useEffect(() => {
    if (id) handleGet(id);
    handleGetUsers();
    handleGetMarriage();
  }, []);

  return (
    <div>
      <Grid container spacing={1}>
        <Grid size={12}>
          <Typography fontSize={18} fontWeight={500} color="#1F2937">
            {id ? "Edit Relationship" : "Add Relationship"}
          </Typography>
        </Grid>

        <Grid size={12}>
          <Box display="grid">
            <FormLabel>
              Person <span style={{ color: "red", marginRight: 4 }}>*</span>
            </FormLabel>

            <Select
              size="small"
              value={formData?.person ? formData?.person : 0}
              onChange={(e) => handleChange("person", e.target.value)}
            >
              {userData?.map((item: any) => (
                <MenuItem key={item?.id} value={item?.id}>
                  {item?.name}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Grid>

        <Grid size={12}>
          <Box display="grid">
            <FormLabel>
              Of Person <span style={{ color: "red", marginRight: 4 }}>*</span>
            </FormLabel>

            <Select
              size="small"
              value={formData?.of_person ? formData?.of_person : 0}
              onChange={(e) => handleChange("of_person", e.target.value)}
            >
              {userData?.map((item: any) => (
                <MenuItem key={item?.id} value={item?.id}>
                  {item?.name}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Grid>

        <Grid size={12}>
          <Box display="grid">
            <FormLabel>
              Marriage
            </FormLabel>

            <Select
              size="small"
              value={formData?.marriage_id ? formData?.marriage_id : 0}
              onChange={(e) => handleChange("marriage_id", e.target.value)}
            >
              {Marriage?.map((item: any) => (
                <MenuItem key={item?.id} value={item?.id}>
                  {item?.man?.name}- {item?.woman?.name}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Grid>

        <Grid size={12}>
          <Box display="grid">
            <FormLabel>
              Relation <span style={{ color: "red", marginRight: 4 }}>*</span>
            </FormLabel>
            <Select
              size="small"
              value={formData?.relation ? formData?.relation : 0}
              onChange={(e) => handleChange("relation", e.target.value)}
              displayEmpty
            >
              <MenuItem value="" disabled>
                Select relation
              </MenuItem>
              <MenuItem value="son">Son</MenuItem>
              <MenuItem value="daughter">Daughter</MenuItem>
              <MenuItem value="wife">Wife</MenuItem>
              <MenuItem value="husband">Husband</MenuItem>
              <MenuItem value="father">Father</MenuItem>
              <MenuItem value="mother">Mother</MenuItem>
              {/* Add more options as needed */}
            </Select>
          </Box>
        </Grid>

        <Grid size={12} display="flex" justifyContent="end">
          <Box>
            <Button
              size="small"
              variant="contained"
              sx={{ mx: 1, bgcolor: "#1F2937" }}
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              size="small"
              variant="outlined"
              sx={{ color: "#1F2937", borderColor: "#1F2937" }}
              onClick={onClose}
            >
              Close
            </Button>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default RelationshipForm;
